<template>
  <div class="body">
        <div class="box">
          <div class="box_head">
            <h1>인사이트</h1>
          </div>
          <div class="container">
              <div class="calendar">
                <p class="title">
                  월별 가입자 추이
                </p>
                <datepicker v-model="date" format="yyyy-MM-dd"></datepicker>
              </div>
            <div class="box_body">
              <ul class="print_area">
                  <div class="vx-col md:w-1/2 w-full mb-base" >
                      <vx-card class="con_wrap">
                          <vue-apex-charts ref="realtimeChart" class="graph" type="line" v-model="date" :options="lineChartSimple.chartOptions" :series="lineChartSimple.series">
                            <template slot="codeContainer" v-if="lineChartSimple.series">
                                {{ this.lineChartSimple }}
                            </template>
                          </vue-apex-charts>
                      </vx-card>
                  </div>
                <div class="text">
                  <div>
                    <p class="user_month">
                      가입자 : {{userLength}}
                    </p>
                  </div>
                  <div v-for="(item , index) in userList" :key="index">
                    <div v-if="userList[index].list">
                        {{item.name}} : {{item.list.length}}
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'

import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    Datepicker,
    VueApexCharts
  },
  data() {
    return {
      userList:[],
      allUser:[],
      dataList:[],
      userLength:0,
      data_list:[],
      sort_list:[],
      // date: this.$moment(new Date()).format('yyyy-MM-DD'),
      date: this.$moment(new Date()).format('yyyy-MM-DD'),
      lastDate: [],
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
      lineChartSimple: {
        series: [
          {
          name: "Desktops",
          data: []
        }
      ],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: this.themeColors,
          dataLabels: {
            enabled: true
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: '월별 가입자 인사이트',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          xaxis: {
            categories: ['전전월' , '이전월' , '현재'],
          }
        }
      }
    }
  },
  methods: {
    getUserData2() {
          this.lineChartSimple.series[0].data = []
          this.$store.dispatch('insight/getUserJoinType').then(() => {
            //dispatch로 store/insight 경로에 있는 getUserJoinType 액션을 호출한 다음에
            this.userList = JSON.parse(JSON.stringify(this.userType))
            // JSON.parse(JSON.stringify(...)) => data를 해당 this.userList(data에서 선언한 공배열)를 통해 전달함으로써
            // this.userType 객체의 복사본을 얻음
            // 객체는 반드시 기본 객체이어야 하며
            // 브라우저 API 객체 및 프로토타입 속성과 같은 기본 객체는 무시되기 때문에
            // 위 식을 이용함
            this.data_list = []
            for(var j=0; j<3; j++) {
              this.$store.dispatch('insight/getUserJoinMonth', {date:this.$moment(this.date).subtract(j, 'M').format('yyyy-MM-DD'), index:j}).then((resolve) => { //얘만 3번 for룹을 통해 동작
                //dispatch로 store/insight 경로에 있는 getUserJoinMonth 액션을 호출
                // (format 된 date의 값 (yyyy-MM-dd)를 받아와 insight/2021-06-01의 형태의 액션을 호출
                //                                            인자 ---------- 인자
                console.log('test')
                this.data_list.push({date:resolve.date, index: resolve.index, count:this.userMonth.length})
                  // var index = "index"
                  //   var graph = data_list.sort((a, b) => {
                  //     return a[index] - b[index]
                  //   })
                  // for(var k in data_list) {
                  //     Vue.set(graph[k].count)
                  //     //
                  // }
                  // console.log(graph)
                  // console.log(this.dataList.count)
                  // this.lineChartSimple.series[0].data.unshift(this.dataList)

                if(resolve.index == 0) {
                 //------- return
                  this.userLength = this.userMonth.length
                  for(var i=0; i< this.userList.length; i++) {
                    // userList의 길이만큼 for문을 돌려서
                    var list = this.userMonth.filter((data)=> {
                      // 변수 list에는 userMonth의 data 를 필터링하고
                      return data.user_join_type_id == this.userList[i].id
                      // userMonth.data 내부의 user_join_type_id 와 위의 userList 내부의 객체를 비교하여 동일한 값을 리턴값으로 전달
                    })
                    Vue.set(this.userList[i], 'list', list)
                    // Vue.set == 객체에 대한 속성을 설정
                    // Vue.set을 이용해 userList 배열안에 list속성을 생성한뒤, 위 변수 list를 집어넣음
                    // return data.user_join_type_id == this.userList[i].id 을 받아 정렬된 배열 생성
                }
                }
              })
            }


            // console.log(this.lineChartSimple.series[0].data)
          })
      }
  },
  // var array = this.lineChartSimple.series[0].data
  //   array.push(this.userMonth.length)
  watch: {
    data_list() {
      this.sort_list = JSON.parse(JSON.stringify(this.data_list))
      this.sort_list = this.sort_list.sort(function(a,b) {
        return a.index > b.index ? -1 : a.index > b.index ? 1 : 0
      })
      this.dataList = []
      for(var i in this.sort_list) {
        this.dataList.push(this.sort_list[i].count)
        console.log(this.sort_list[i].count)
      }
      if(this.dataList.length == 3) {
        // this.lineChartSimple.series[0].data = this.dataList
        this.$refs.realtimeChart.updateSeries([{
        data:this.dataList,
      }], false, true);
        console.log(this.dataList)
      }
    },
    // 위 templete 영역에서 v-model로 양방향간에 데이터를 전달받을 수 있음
    // 달력 클릭시 date의 날짜 변화를 감지하기 위해 watch
    date() {
      // this.lastDate.splice(0)
      // this.lineChartSimple.series[0].data.splice(0)
      // for(var i=2; i>=0; i--) {
      //   this.lastDate.push(this.$moment(this.date).subtract(i, 'M').format('yyyy-MM-DD'))
      // }
      this.getUserData2()
    }
  },
  created() {
      // this.lastDate.splice(0)
      // this.lineChartSimple.series[0].data.splice(0)
      // for(var i=2; i>=0; i--) {
      //   this.lastDate.push(this.$moment(this.date).subtract(i, 'M').format('yyyy-MM-DD'))
      // }
      this.getUserData2()
        // getUserData에 this.$moment(this.date).subtract(i, 'M').format('yyyy-MM')를 인자로 집어넣음

        // splice(startIndex , endIndex) == 배열 초기화
      // }
      // this.getUserData(this.lastDate)
      // console.log(this.lastDate)
        // getUserData에 this.$moment(this.date).subtract(i, 'M').format('yyyy-MM')를 인자로 집어넣음

        // splice(startIndex , endIndex) == 배열 초기화
    },
  computed: {
    userMonth() {
      return this.$store.state.insight.userMonth
    },
    userType() {
      return this.$store.state.insight.userType
    },
  }
  }
</script>

<style lang="css" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  box-sizing: border-box;
}
  .body {
    background-color: none;
    width: 100%;
  }
  .wrap {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 1em;
    padding: 0 5px;
  }
  .title {
    width: 100%;
    line-height: 50px;
    font-size: 1.3em;
    color: white;
    font-weight: bold
  }
  .box {
    position: relative;
    width: 100%;
    background-color: black;
    border-radius: 3px;
  }
  .box_head {
    width: 100%;
    height: 80px;
    display: flex;
    font-size: 1.2em;
    border-bottom: 1px solid #333;
  }
  .box_head h1 {
    width: 100%;
    color: white;
    font-weight: bold;
    text-align: center;
    line-height: 80px;
  }
  .box_body {
    width: 100%;
    padding: 30px 15px;
  }
  .container {
    display: flex;
    flex-direction: column;
  }
  .calendar {
    width: 100%;
    display: flex;
    border-bottom: 1px solid #333;
    padding: 20px;
  }
  .con_wrap {
    width: 100%;
    min-width: 500px;
    margin: 0 auto;
  }
  .vdp-datepicker {
    position: absolute;
    width: 100%;
    max-width: 300px;
    right: 20px;
  }
  .vdp-datepicker input {
    background: black;
    border: 1px solid #333;
    border-radius: 20px;
  }
  .vx-col {
    width: 100%;
    min-width: 500px;
    margin: 0 auto;
  }
  .print_area {
    text-align: center;
    color: white;
  }
  .user_month {
    font-size: 2em;
    margin-top: 40px;
  }
</style>
